var isClassComponent = function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent;
};
var isFunctionComponent = function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('createElement');
};

var isReactComponent = function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component);
};

export { isClassComponent, isFunctionComponent, isReactComponent };
